module.exports = __webpack_public_path__ + "static/media/climate-change.8992b180.png";